import React from "react";
import { ClipboardListIcon, ClockIcon, HelpCircleIcon, LayersIcon, SearchIcon, TargetIcon, BoxIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { painPoints } from "../data/painPoints";
const ICONS: Record<string, BoxIcon> = {
  layers: LayersIcon,
  clock: ClockIcon,
  help: HelpCircleIcon,
  clipboard: ClipboardListIcon,
  search: SearchIcon,
  target: TargetIcon
};
export function PainPoints() {
  return <section className="bg-brand-soft px-4 py-16 sm:py-24" data-id="element-261" data-mp="21z37j5986inr">
      <SectionHeading eyebrow="Does any of this sound familiar?" title="If You’ve Experienced Even One of These Situations, I Created This System With You in Mind." data-id="element-262" data-mp="220o1otrmnzl3" />

      <div className="mx-auto mt-10 grid max-w-6xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-263" data-mp="1szptdza5p5wp">
        {painPoints.map(p => {
        const Icon = ICONS[p.icon];
        return <article key={p.title} className="flex flex-col rounded-2xl bg-white p-5 shadow-[0_1px_0_rgba(23,22,58,0.06)] sm:p-6" data-id="element-264" data-mp="3nd7llzliaqy2">
              <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand text-white" data-id="element-265" data-mp="1yzdmikt6g9m0">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-266" data-mp="1u0so8qxhk007" />
              </span>
              <h3 className="mt-4 text-[18px] font-bold leading-snug text-ink" data-id="element-267" data-mp="27rxfb4msfjyx">{p.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-268" data-mp="23r56udlqpj3p">{p.text}</p>
            </article>;
      })}
      </div>

      <div className="mx-auto mt-12 max-w-2xl space-y-4 text-center text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-269" data-mp="1g2chx13jcbil">
        <p className="font-serif text-[24px] font-extrabold italic leading-snug text-ink sm:text-3xl" data-id="element-270" data-mp="1b4st5797ogce">And it shouldn’t have to feel this complicated.</p>
        <p data-id="element-271" data-mp="1k34plpwre8cr">When you’re dealing with a complex case, the problem isn’t necessarily that you lack knowledge.</p>
        <p className="text-ink" data-id="element-272" data-mp="30gmlvj6m4hi2">
          <strong data-id="element-273" data-mp="30jqwozel2bhp">Sometimes, the missing piece is a practical structure for organizing the knowledge you already have.</strong>
        </p>
        <p data-id="element-274" data-mp="1t5oi4vgv83w9">
          That’s the idea behind the Sensory Modulation Clinical Pathway™. I created it to help you move from isolated observations toward a
          more organized exploration of the case.
        </p>
      </div>

      <CTAButton className="mt-8" label="Yes, I want a more structured approach" data-id="element-275" data-mp="226wcx3k6amll" />
    </section>;
}